import { fetchAdminV1 } from "../lib/requester/v1";

export const generateVendorToken = (role, email, fullName, companyName) => {
  return fetchAdminV1("/vendor-tokens/generate-registration", {
    method: "POST",
    data: { role, email, fullName, companyName }
  }, {
    returnWholeResponse: true
  });
};

export const getAllVendorTokens = () => {
  return fetchAdminV1("/vendor-tokens/get-all-tokens", { method: "GET" }, { returnWholeResponse: true });
};

export const revokeVendorToken = (tokenId) => {
  return fetchAdminV1(`/vendor-tokens/${tokenId}`, { method: "DELETE" }, { returnWholeResponse: true });
}; 